import React from 'react';
import ReactDOM from 'react-dom';

export function autoInjectComponents(registeredComponents) {
  document.querySelectorAll('.react-component').forEach(container => {
    const { name, props } = container.dataset;

    if (!registeredComponents[name]) {
      console.error(
        'Trying to inject a component that is not registered: ' + name
      );
      return;
    }

    ReactDOM.render(
      React.createElement(registeredComponents[name], JSON.parse(props)),
      container
    );
  });
}
